import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Button, ContentSection, Fieldset, Layout, SectionHeading, Select } from '@vwfs-bronson/bronson-react';
import { OutletSearchCombobox } from '../../components/OutletSearchCombobox/OutletSearchCombobox';
import { Analytics } from '../../services/analytics';
import { outletPageEvent } from '../../services/analytics/analyticsEvents';
import { loginAsOutlet } from '../../services/api/authorization';
import { brokerSelectors } from '../../services/redux/features/broker.slice';

export const OutletPage: FunctionComponent = () => {
  const { t } = useTranslation();
  const [mainHeight, setMainHeight] = useState(undefined as any);
  const allowedCompaniesSortedByBer = useSelector(brokerSelectors.allowedCompaniesSortedByBerCode);
  const currentCompany = useSelector(brokerSelectors.currentCompany);
  const [selectedCompany, setSelectedCompany] = useState(currentCompany);

  const selectedCompanyIndex =
    allowedCompaniesSortedByBer.findIndex(({ milesCompanyId }) => selectedCompany?.milesCompanyId === milesCompanyId) ??
    0;

  useEffect(() => {
    Analytics.push(outletPageEvent);

    const getMainHeight = () => document.querySelector<HTMLElement>('.o-main')?.offsetHeight;
    setMainHeight(getMainHeight());
  }, []);

  const login = async () => {
    if (!selectedCompany) return;
    await loginAsOutlet(selectedCompany.milesCompanyId!, true);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: mainHeight,
      }}
      className="u-mb@s"
    >
      <SectionHeading center level={2} className="u-mb">
        {t('outletPage:title')}
      </SectionHeading>
      <ContentSection className="u-ph-large u-pv-small">
        <Fieldset>
          <Fieldset.Row>
            <Layout center>
              <Layout.Item default="1/3" l="1/2" s="1/1">
                {allowedCompaniesSortedByBer.length > 6 && (
                  <OutletSearchCombobox
                    allowedCompanies={allowedCompaniesSortedByBer}
                    onSelectedCompanyChange={setSelectedCompany}
                    selectedCompany={selectedCompany}
                  />
                )}

                {allowedCompaniesSortedByBer.length <= 6 && (
                  <Select
                    disabled={allowedCompaniesSortedByBer.length === 1}
                    onChange={(e) => {
                      setSelectedCompany(allowedCompaniesSortedByBer[e.target.value]);
                    }}
                    value={String(selectedCompanyIndex)}
                  >
                    {allowedCompaniesSortedByBer?.map((company, i) => {
                      const label = `${company.milesBerCode} - ${company?.brand?.name}`;
                      const key = `${label} - ${i}`;
                      const index = String(i);
                      return (
                        <Select.Item key={key} value={index}>
                          {label}
                        </Select.Item>
                      );
                    })}
                  </Select>
                )}
              </Layout.Item>
            </Layout>
          </Fieldset.Row>
          <Fieldset.Row className="u-text-center u-mt-small">
            <Layout center>
              <Button
                id="login"
                testId="login"
                type="button"
                disabled={!allowedCompaniesSortedByBer.length}
                onClick={login}
              >
                {t('outletPage:nextButton')}
              </Button>{' '}
            </Layout>
          </Fieldset.Row>
        </Fieldset>
      </ContentSection>
    </div>
  );
};
